module.exports = __webpack_public_path__ + "img/banner-about.1f857bdd.jpg";